// extracted by mini-css-extract-plugin
export var divider = "_fs-7";
export var itemsToggle = "_fs-8";
export var mergeModal = "_fs-1";
export var optionCard = "_fs-4";
export var radioGroup = "_fs-6";
export var radioOption = "_fs-0";
export var selected = "_fs-5";
export var shipmentOptions = "_fs-2";
export var tableOptions = "_fs-3";